"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = AdditionalEquipmentUi;
var _react = _interopRequireDefault(require("react"));
var _stepLayout = _interopRequireDefault(require("../../_common/step-layout/step-layout"));
var _equipmentList = _interopRequireDefault(require("./equipment-list/equipment-list"));
function AdditionalEquipmentUi(_ref) {
  var _ref$equipmentList = _ref.equipmentList,
    equipmentList = _ref$equipmentList === void 0 ? [] : _ref$equipmentList,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$disclaimerData = _ref.disclaimerData,
    disclaimerData = _ref$disclaimerData === void 0 ? {} : _ref$disclaimerData,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme,
    disclaimer = _ref.disclaimer,
    direction = _ref.direction,
    onEquipmentOptionSelected = _ref.onEquipmentOptionSelected,
    market = _ref.market,
    selectedModelCode = _ref.selectedModelCode,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId;
  var selectedModel = equipmentList.find(function (equipment) {
    return equipment.code === selectedModelCode;
  }) || {};
  var selectedCarousel = selectedModel.carousel;
  return /*#__PURE__*/_react["default"].createElement(_stepLayout["default"], {
    title: title,
    direction: direction,
    theme: theme,
    disclaimerData: disclaimerData,
    carouselData: selectedCarousel,
    disclaimer: disclaimer,
    market: market,
    rightSlot: selectedModelCode && /*#__PURE__*/_react["default"].createElement(_equipmentList["default"], {
      equipmentList: equipmentList,
      theme: theme,
      onEquipmentOptionSelected: onEquipmentOptionSelected,
      selectedModelCode: selectedModelCode,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    })
  });
}